module.exports = {
    shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],

    /* 01. Common */
    'common.actions.add': 'Add',
    'common.actions.confirm': 'Confirm',
    'common.actions.submit': 'Submit',
    'common.actions.cancel': 'Cancel',
    'common.actions.loading': 'Loading...',
    'common.actions.update': 'Update',
    'common.actions.orderby': 'Order By',
    'common.actions.lockScreen': 'Lock Screen',
    'common.actions.allDevices': 'All Devices',
    'common.actions.messages': 'Messages',
    'common.actions.changePassword': 'Change Password',
    'common.actions.logout': 'Logout',
    'common.actions.createVoucher': 'Create Voucher',
    'input.placeholder.voucherInputPlaceholder': 'Enter amount',
    'common.actions.checkIt': 'Check It',
    'common.actions.addTicket': 'Add To Betslip',

    'common.list': 'List',
    'common.cashier': 'Cashier',
    'common.confirmDeleteTitle': 'Are you sure to delete?',
    'common.currentLimit': 'Current Balance',
    'common.remainingLimit': 'Current Balance',
    'common.live': 'Live',
    'common.booked': 'L',
    'common.goal': 'goal',

    /* ================================================================================================================================ */

    /* 02. Menu */
    'menu.home': 'Home',
    'menu.sports': 'Sports',
    'menu.live': 'Live',
    'menu.e-sports': 'E-Sports',
    'menu.prematch': 'Prematch',
    'menu.results': 'Results',
    'menu.printProgram': 'Print The Program',
    'menu.dailyReport': 'Report',
    'menu.balanceReport': 'Balance Report',
    'menu.point': 'Others',
    'menu.point.creditLimit': 'Interim Payment',
    'menu.actions.playNow': 'Play Now',
    'menu.actions.playLive': 'Play Live',
    'menu.actions.look': "Let's look",
    'menu.actions.printNow': 'Print Now',
    'menu.actions.increase': 'Increase',
    'menu.actions.creditBalance': 'Credit',

    /* ================================================================================================================================= */

    /* 03. Input & SelectBox */
    'input.placeholder.voucherAmount': 'Voucher Amount',
    'input.placeholder.scanBarcode': 'Scan or Enter Barcode',
    'input.placeholder.eventIdOrEventName': 'Input Event ID or Event Name',
    'input.placeholder.shortCode': 'Shortcode',
    'selectbox.selectMarket': 'Select Market',
    'selectbox.selectOutcome': 'Select Outcome',

    /* ================================================================================================================================= */

    /* 04. Login */
    'login.message.welcomeTo': 'Welcome!',
    'login.message.userPanel': 'User Interface for Cashier',
    'login.message.sport': 'Sport',
    'login.message.sportMean': 'is a means of raising people both physically and morally',
    'login.input.username': 'Username',
    'login.input.password': 'Password',
    'login.input.show': 'Show',
    'login.input.hide': 'Hide',
    'login.actions.login': 'Login',
    'login.actions.loading': 'Loading...',

    /* ================================================================================================================================= */

    /* 05. Filter & Sort */
    'filter.allCountries': 'All Countries',
    'filter.allCategories': 'All Categories',
    'filter.allLeagues': 'All Leagues',
    'filter.allTimes': 'All Times',
    'sort.byLeague': 'Sort By League',
    'sort.byTime': 'Sort By Time',
    'sort.byDescending': 'By descending',
    'sort.byAscending': 'By ascending',

    /* ================================================================================================================================= */

    /* 06. Title */
    'title.sports': 'Sports',
    'title.prematch': 'Prematch',
    'title.messages': 'Messages',
    'title.point': 'Others',
    'title.terminals': 'Terminals',
    'title.tickets': 'Tickets',
    'title.sportsBook': 'Sportsbook Print',
    'title.reports': 'Reports',
    'title.weeklyBalance': 'Balance Report',
    'title.creditLimit': 'Interim Payment Report',
    'title.consumptions': 'Consumptions',
    'title.results': 'Results',

    /* ================================================================================================================================= */

    /* 07. Betslip */
    'betSlip.emptyMessage': 'Your bet slip is empty. Click on any price to add a bet',
    'betSlip.betLine.return': 'Possible Win',
    'betSlip.betLine.betMax': 'Bet Max',
    'betSlip.betLine.closed': 'Closed',
    'betSlip.select.option.dontAccept': 'Don’t Accept If Odds Change',
    'betSlip.select.option.acceptAny': 'Accept Any Change',
    'betSlip.select.option.acceptIncrease': 'Accept If Odds Increase',
    'betSlip.combinations': 'Combinations',
    'betSlip.actions.clearAll': 'Clear All',
    'betSlip.actions.placeBets': 'Place Bet',
    'betSlip.summary.numberOfBets': 'Number of Bets',
    'betSlip.summary.totalStake': 'Total Stake',
    'betSlip.summary.totalOdds': 'Total Odds',
    'betSlip.summary.toWin': 'Possible Win',
    'betSlip.summary.system': 'System',
    'betSlip.errors.wrongMarketSelectionCombo': 'Wrong Market Selection for Combo',
    'betSlip.errors.combinationOptions': 'Please, review combination options for your selections.',
    'betSlip.placeBets.betsInProcess': 'Bets in Process…',
    'betSlip.refresh.loadingTitle': 'Refreshing',
    'betSlip.placeBets.loadingInfoMessage': 'Your bet is loaded into the system',
    'betSlip.refresh.loadingInfoMessage': 'We are fetching the latest updates...',
    'betSlip.placeBets.successMessage': 'Bet(s) Accepted!',
    'betSlip.placeBets.ticketNumber': 'Ticket Number',
    'betSlip.placeBets.betId': 'Bet ID',
    'betSlip.placeBets.bonus': 'Bonus Amount',
    'betSlip.placeBets.winTax': 'Win Tax',
    'betSlip.placeBets.potentialPayout': 'Net Win',
    'betSlip.placeBets.windowWillClose': 'Window Will Close',
    'betSlip.placeBets.acceptOddChanges': 'Accept Odds Changes',
    'betSlip.actions.retainSelections': 'Retain Selections',
    'betSlip.actions.clear': 'Clear',
    'betSlip.actions.autoAccept': 'Auto Accept',
    'betSlip.actions.manually': 'Manually',

    /* Misc */
    langDropdownAze: 'Azeri',
    comingSoon: 'Coming Soon',
    allDevicesModalTitle: 'Cashier Devices',
    allDevicesModalDescription:
        'Please always keep your devices operational. This will make your work more sustainable.',
    allDevicesModalInternetConnection: 'Internet Connection',
    allDevicesModalPrinter: 'Printer',
    allDevicesModalScanner: 'Scanner',
    allDevicesModalRefresh: 'Refresh',
    allDevicesModalDone: 'Done',
    lockScreenModalTitle: `Your account is currently locked.`,
    lockScreenModalDescription: `You can open the account by entering your password in the appropriate box.`,
    lockScreenModalEnterPassword: `Enter Your Password`,
    lockScreenModalSubmitting: `Opening...`,
    lockScreenModalSubmitButton: `Open`,
    messagesTabsAll: `All`,
    messagesTabsRead: `Read`,
    messagesTabsNew: `New`,
    messagesTabsSaved: `Saved`,
    messagesTableColumnsNo: `No`,
    messagesTableColumnsType: `Status`,
    messagesTableColumnsMessageId: `Message ID`,
    messagesTableColumnsMessage: `Message`,
    messagesTableColumnsDate: `Date/Time`,
    messagesTableRowMore: `More`,
    messagesTableRowMessageStatusNew: `New`,
    messagesTableRowMessageStatusSaved: `Saved`,
    messagesTableRowMessageStatusRead: `Read`,
    messagesTableRowMoreModalSaveButton: `Save`,
    messagesTableRowMoreModalPrintButton: `Print`,
    messagesTableRowMoreModalMessageId: `Message ID :`,
    messagesPriority: 'Priority',
    messagesPriorityLow: 'Low',
    messagesPriorityHigh: 'High',
    betSlipCombinationsSelection: `Combinations`,
    betSlipCombinationsSelectionSelected: `Selected`,
    betSlipCombinationsBets: `Bets`,
    othersSidebarTerminals: 'Terminals',
    othersSidebarTickets: 'Tickets',
    othersSidebarSportsbookPrint: 'Sportsbook',
    othersSidebarReports: 'Reports',
    othersSidebarBalanceReport: 'Balance Report',
    othersSidebarCreditLimitIncreaseReport: 'Interim Payment Report',
    othersSidebarConsumptions: 'Consumptions',
    terminalsTableColumnsNo: 'No',
    terminalsTableColumnsTerminalCode: 'Terminal Code',
    terminalsTableColumnsStatus: 'Status',
    terminalsTableColumnsCurrentBalance: 'Current Balance',
    languagesEnglish: 'English',
    languagesAzerbaijani: 'Azeri',
    eventsFiltersCategoriesAll: 'All Categories',
    eventsFiltersLeaguesAll: 'All Leagues',
    eventsFiltersLeaguesFavorites: 'Favorites',
    eventsFiltersLeaguesOutrights: 'Outrights',
    eventsFiltersPeriodsAll: 'All Times',
    eventsFiltersPeriodsFirstItem: 'Next 6 hours',
    eventsFiltersPeriodsSecondItem: 'Today',
    eventsFiltersPeriodsThirdItem: 'Tomorrow',
    eventsFiltersPeriodsFourthItem: 'This Week',
    eventsFiltersPeriodsFifthItem: 'Next 24 hours',
    eventsFiltersOrdersFirstItem: 'Sort By League',
    eventsFiltersOrdersSecondItem: 'Sort By Time',
    eventsFiltersOrdersThirdItem: 'Sort By MBN',
    balanceReportsTabsCashier: 'Cashier',
    balanceReportsTabsTerminals: 'Terminals',
    balanceReportsAllTerminals: 'All',
    betSlipTabsSingle: 'Single',
    betSlipTabsCombo: 'Combo',
    betSlipTabsSystem: 'System',
    betSlipErrorsSingleMbn: 'MBN not allowed.',
    betSlipErrorsComboMbn: 'MBN not allowed.',
    betSlipErrorsCombination: 'Please, review combination options for your selections.',
    betSlipErrorsEventTypeCombination:
        'Combination of these type bets (cybersports, normal, outrights) are not allowed.',
    betSlipErrorsMbnCombination: 'MBN combinations not allowed.',
    betSlipErrorsMinStake: 'Minimum stake value is %(amount)s AZN',
    betSlipErrorsMaxStake: 'Maximum stake value is %(amount)s AZN',
    betSlipErrorsMinimumOdd: 'Odds under minimum allowed',
    betSlipErrorsMinimumTotalOdd: 'Total odds under minimum allowed',
    betSlipPlacedTicketFoldCount: '%(count)s fold',
    betSlipPlacedTicketFoldsCount: '%(count)s folds',
    betSlipPlacedTicketBetCount: '%(count)s bet',
    betSlipPlacedTicketBetsCount: '%(count)s bets',
    numericKeyboardSubmit: 'Submit',
    changePasswordModalTitle: 'Change your password',
    changePasswordModalOldPassPlaceholder: 'Enter Old Password',
    changePasswordModalNewPassPlaceholder: 'Enter New Password',
    changePasswordModalConfirmNewPassPlaceholder: 'Confirm New Password',
    changePasswordModalChangeButton: 'Change Password',
    changePasswordModalSuccessMessage: 'Successfully Changed!',
    bancoButton: 'B',
    interfaceLoadingLabel: 'Loading Bet Interface',
    headerOpenSession: 'Session is open',
    errorModalRefreshButton: 'Refresh',
    errorModalLogoutButton: 'Logout',
    errorModalCloseButton: 'Close',
    errorModalRetryButton: 'Retry',
    logoutModalTitle: 'Logout',
    logoutModalContent: 'Are you sure you want to log out?',
    logoutModalYesButton: 'Yes',
    logoutModalNoButton: 'No',
    ticketInformationPayWinButton: 'Pay Win',
    ticketInformationPayWinMaxPayAmountError:
        "Pay amount is greater than cashier's max payment limit",
    ticketInformationReprintButton: 'Reprint',
    ticketInformationReprintRequestButton: 'Reprint Request',
    ticketInformationAddToBetSlipButton: 'Add to BetSlip',
    ticketInformationReprintRequestSuccess: 'Successfully sent reprint request',
    ticketInformationCancelButton: 'Cancel ticket',
    ticketInformationCancelLoading: 'Ticket cancelling',
    ticketStatusAll: 'All',
    ticketStatusOpen: 'Open',
    ticketStatusCancelled: 'Cancelled',
    ticketStatusWon: 'Won',
    ticketStatusLost: 'Lost',
    ticketStatusDraw: 'Draw',
    ticketStatusVoid: 'Void',
    ticketStatusHalfLost: 'Half-Lost',
    ticketStatusHalfWon: 'Half-Won',
    ticketStatusRefunded: 'Refunded',
    ticketStatusPaid: 'Paid',
    ticketStatusCashOut: 'Cashout',
    voucherStatusAll: 'All',
    voucherStatusActive: 'Active',
    voucherStatusInactive: 'Inactive',
    voucherStatusCancelled: 'Cancelled',
    voucherInformationCancelLoading: 'Voucher cancelling',
    terminalStatusActive: 'Active',
    terminalStatusInactive: 'Inactive',
    ticketInformationBetLineStatusColumn: 'Status',
    ticketInformationEventIdColumn: 'Event ID',
    ticketInformationBetLineBancoColumn: 'Banco',
    ticketInformationBetLineDateColumn: 'Date',
    ticketInformationBetLineEventColumn: 'Event',
    ticketInformationBetLineLeagueColumn: 'League',
    ticketInformationBetLineScoreColumn: 'Score',
    ticketInformationBetLineMatchScoreColumn: 'Match Score',
    ticketInformationBetLineSelectionColumn: 'Selection',
    ticketInformationBetLineOddsColumn: 'Odds',
    ticketInformationBetLineDescriptionColumn: 'Description',
    ticketInformationBetLineStakeColumn: 'Stake',
    ticketInformationTitle: 'Ticket Information',
    ticketInformationTerminalNameColumn: 'Terminal Name',
    ticketInformationBetId: 'Bet ID',
    ticketInformationDateColumn: 'Ticket Date',
    ticketInformationNumberColumn: 'Barcode',
    ticketInformationTotalOddsColumn: 'Total Odds',
    ticketInformationTotalCostColumn: 'Ticket Cost',
    ticketInformationStakePerBetColumn: 'Stake Per Bet',
    ticketInformationVoucherColumn: 'Voucher Code',
    ticketInformationExtraWinColumn: 'Extra Win',
    ticketInformationToWinColumn: 'To Win',
    ticketInformationWinTaxColumn: 'Win Tax',
    ticketInformationToPayColumn: 'To Pay',
    ticketInformationPaidByColumn: 'Paid by',
    ticketInformationPaidDateColumn: 'Paid Date',
    ticketInformationPaidColumn: 'Paid',
    ticketInformationHeaderBetType: 'Bet Type:',
    ticketModalNotFoundError:
        'Ticket was not created or is being created. Try again in a few moments',
    increaseReportErrorModalGoBackButton: 'Go Back',
    increaseReportErrorModalDefaultMessage: 'Something went wrong',
    increaseReportSuccessMessage: 'Successfully received increase request',
    increaseReportIncreaseButton: 'Increase',
    increaseReportSuccessModalOkButton: 'Confirm',
    increaseReportSuccessModalTitle: 'Are You Sure?',
    filtersStartDatePlaceholder: 'Start date',
    filtersEndDatePlaceholder: 'End date',
    filtersSearchButton: 'Search',
    filtersClearButton: 'Clear',
    notAvailableDate: 'Not Available',
    balanceReportSummaryTablePaymentColumn: 'Payment',
    balanceReportSummaryTableLimitIncreaseColumn: 'Interim Payments',
    balanceReportSummaryTableExtraDebtColumn: 'Extra Debt/Credit',
    balanceReportSummaryTableDebtColumn: 'Debt/Credit',
    balanceReportSummaryTableCreditColumn: 'Credit',
    balanceReportSummaryTableTotalDebtColumn: 'Total Debt/Credit',
    balanceReportSalesColumn: 'Sales',
    balanceReportTicketCountColumn: 'Tickets',
    balanceReportAgentCommissionColumn: 'Commissions',
    balanceReportTotalSaleColumn: 'Total',
    balanceReportCancellationColumn: 'Cancels',
    balanceReportTotalCancellationColumn: 'Total',
    balanceReportPaymentColumn: 'Payments',
    balanceReportTotalPaymentColumn: 'Total',
    balanceReportRefundColumn: 'Refunds',
    balanceReportTotalRefundColumn: 'Total',
    balanceReportRefundCommissionColumn: 'Refunds Commission',
    balanceReportTotalRefundCommissionColumn: 'Total',
    balanceReportVoucherSaleColumn: 'Voucher Sales',
    balanceReportVoucherCancelColumn: 'Voucher Cancels',
    balanceReportTotalVoucherSaleColumn: 'Total',
    balanceReportVoucherRefundColumn: 'Voucher Refunds',
    balanceReportVoucherBetsColumn: 'Voucher Bets',
    balanceReportTotalVoucherRefundColumn: 'Total',
    balanceReportVoucherCountColumn: 'Vouchers',
    balanceReportSportsBettingPrematch: 'Sports Betting - Prematch',
    balanceReportSportsBettingLive: 'Sports Betting - Live',
    balanceReportTotalColumn: 'Total',
    balanceReportTerminalsSelectPlaceholder: 'Terminals',
    balanceReportOnlineVoucherSalesColumn: 'Online Voucher Sales',
    balanceReportOnlineVoucherRefundsColumn: 'Online Voucher Refunds',
    increaseReportsTableNoColumn: 'No',
    increaseReportsStatusColumn: 'Status',
    increaseReportsAmountColumn: 'Amount',
    increaseReportsRequestDateColumn: 'Request Date / Time',
    increaseReportsProcessingDateColumn: 'Processing Date / Time',
    increaseReportsStatusAll: 'All',
    increaseReportsStatusPending: 'Pending',
    increaseReportsStatusSuccessful: 'Successful',
    increaseReportsStatusFail: 'Fail',
    increaseReportsStatusBOIncrease: 'BO Increase',
    increaseReportsStatusBODecrease: 'BO Decrease',
    increaseReportsStatusCreditIncrease: 'Credit',
    sportsbookPreviewButton: 'Preview',
    ticketsFiltersOrdersAscending: 'By ascending',
    ticketsFiltersOrdersDescending: 'By descending',
    ticketsTabsOpenBets: 'Open Bets',
    ticketsTabsBettingHistory: 'Betting History',
    ticketsTabsVouchers: 'Vouchers',
    ticketsTableNoColumn: 'No',
    ticketsTableStatusColumn: 'Status',
    ticketsTableTerminalColumn: 'Terminal',
    ticketsTableBetIdColumn: 'Bet ID',
    ticketsTableBarcodeColumn: 'Barcode',
    ticketsTableTimeColumn: 'Time',
    ticketsTableTicketCostColumn: 'Ticket Cost',
    ticketsTableMaxWinColumn: 'Max. Win',
    ticketsTableBetTypeColumn: 'Bettype',
    ticketsTableDetailsButton: 'Details',
    voucherTableNoColumn: 'No',
    voucherTableStatusColumn: 'Status',
    voucherTableIdColumn: 'Voucher ID',
    voucherTableCodeColumn: 'Voucher Code',
    voucherTableCashierCodeColumn: 'Cashier Code',
    voucherTableTerminalCodeColumn: 'Terminal Code',
    voucherTableCreateDateColumn: 'Create Date',
    voucherTableIssueDateColumn: 'Redeem Date',
    voucherTableExpireDateColumn: 'Expire Date',
    voucherTableCancellationDateColumn: 'Cancellation Date',
    voucherTableAmountDateColumn: 'Amount',
    voucherCodeInputPlaceholder: 'Voucher Code',
    voucherType: 'Voucher Type',
    voucherTerminalCode: 'Terminal Code',
    voucherInformationTitle: 'Voucher Information',
    voucherInformationCancelButton: 'Cancel voucher',
    resultsFiltersAllCategories: 'All Categories',
    resultsFiltersAllLeagues: 'All Leagues',
    resultsFiltersOrdersByTime: 'By Time',
    resultsFiltersOrdersByLeague: 'By League',
    resultsTableEventDateColumn: 'Event Date/Time',
    resultsTableEventIdColumn: 'Event ID',
    resultsTableCategoryColumn: 'Category',
    resultsTableLeagueColumn: 'League',
    resultsTableEventColumn: 'Event',
    resultsTableFullTimeColumn: 'Full Time',
    closeButton: 'Close',
    generalErrorModalTitle: 'Error',
    generalErrorModalDescription: 'There is an issue occurred.',
    changePasswordSuccessMessage: 'Changed password successfully.',
    filtersRanges3Hours: '3 hours',
    filtersRanges6Hours: '6 hours',
    filtersRanges12Hours: '12 hours',
    filtersRangesToday: 'Today',
    filtersRangesYesterday: 'Yesterday',
    filtersRangesThisWeek: 'This Week',
    filtersRangesLastWeek: 'Last Week',
    filtersRangesThisMonth: 'This Month',
    filtersRangesLastAccountingPeriod: 'Last Week',
    filtersRangesLastMonth: 'Last Month',
    filtersRangesRangeOption: 'Range',
    ticketsFiltersSourcesAll: 'All',
    ticketsFiltersSourcesCashier: 'Cashier',
    ticketsFiltersSourcesTerminal: 'Terminal',
    increaseReportRequestAmountPlaceholder: 'Amount',
    marketGroupsAllOption: 'All',
    marketGroupsExpand: 'Expand',
    marketGroupsCollapse: 'Collapse',
    marketGroupsMorePlaceholder: 'More...',
    betSlipErrorsMaxWin: 'Maximum win amount limit exceed',
    betSlipErrorsMaxBetLine: 'Maximum bet line count is %(count)s',
    searchResultNoOptions: 'No options',
    preMatchProducerIsDown: 'Pre-Match producer is down',
    liveProducerIsDown: 'Live producer is down',
    popularEvents: 'Popular Events',
    couponNotFound: 'Coupon not found',
    betSlipErrorsOddChange: 'Odds have changed',
    betSlipErrorsModal: 'Betting failed!',
    print: 'Print',
    noMarketsAvailable: 'No markets available',
    internetConnectionOnline: 'Online',
    internetConnectionOffline: 'Offline',
    socketConnectionIsDown: 'Socket connection lost!',
    socketConnectionDownHelp: 'Please refresh page to get the latest data.',
    socketConnectionRefreshButton: 'Reload',
    newVersionNotificationMessage: 'New version is available',
    newVersionNotificationReload: 'Reload',
    increaseBalanceMinimumAmountValidation: 'Minimum amount should be %(amount)s AZN',
    increaseBalanceMaximumAmountValidation: 'Maximum amount should be %(amount)s AZN',
    increaseBalanceDivisibleByValidation: 'Amount should be in form of 200, 300, 400, and so on',
    duplicateTicketCodeError: 'Error %(code)s "Duplicated Barcode"',
    increaseInterimCreditSuccess: 'Increased credit: %(amount)s AZN',
    eventTypesRegular: 'Regular',
    eventTypesOutright: 'Outrights',
    exportButton: 'Unused Vouchers',
    newMarketIcon: 'NEW',
};
